import { iniciarRequisicao, logout } from "@/helpers";
import API from "@/api/api";
import { STATUS_HTTP} from "@/api/statusHTTP";

export const getGrupoSeparacao = async () => {
  const { data, status } = await API.get('drp/mapa-de-separacao/get-grupo-separacao', { headers: iniciarRequisicao() }).catch(logout)
  if (status !== STATUS_HTTP.OK) logout();
  localStorage.token = data.token;
  return data.grupos_separacao;
}

export const getFiliaisGrupoSeparacao = async (grupo) => {
  const { data, status } = await API.get('drp/mapa-de-separacao/get-filiais-grupo-separacao/' + grupo, { headers: iniciarRequisicao() }).catch(logout)
  if (status !== STATUS_HTTP.OK) logout();
  localStorage.token = data.token;
  return data.filiais_grupos_separacao;
}

export const getMapaSeparacao = async () => {
  const { data, status } = await API.get('drp/mapa-de-separacao', { headers: iniciarRequisicao() }).catch(logout);
  if (status !== STATUS_HTTP.OK) logout();
  localStorage.token = data.token;
  return data.listagem;
}

export const storeMapaSeparacao = async (parametros) => {
  const { data, status } = await API.post('drp/mapa-de-separacao/store', parametros, { headers: iniciarRequisicao() }).catch(logout);
  if (status !== STATUS_HTTP.OK) logout();
  localStorage.token = data.token;
  return ;
}

export const updateMapaSeparacao = async (parametros) => {
  const { data, status } = await API.put('drp/mapa-de-separacao/update', parametros, { headers: iniciarRequisicao() }).catch(logout);
  if (status !== STATUS_HTTP.OK) logout();
  localStorage.token = data.token;
  return ;
}

export const deleteMapaSeparacao = async (parametros) => {
  const { data, status } = await API.post('drp/mapa-de-separacao/delete', parametros, { headers: iniciarRequisicao() }).catch(logout);
  if (status !== STATUS_HTTP.OK) logout();
  localStorage.token = data.token;
  return ;
}

export const deleteFilialGrupoSeparacao = async (parametros) => {
  const { data, status } = await API.post('drp/mapa-de-separacao/delete-filial-grupo-separacao', parametros, { headers: iniciarRequisicao() }).catch(logout);
  if (status !== STATUS_HTTP.OK) logout();
  localStorage.token = data.token;
  return ;
}


